import React from 'react';
import { useLocation } from 'react-router-dom';
import { useCart } from './CartContext';

const ProductCard = React.memo(({ product, onViewDetails }) => {
  const location = useLocation();
  const isHome = location.pathname === '/';
  const { addToCart } = useCart();

  const isFeatureItem = product.type === 'Feature';
  const canAdd = !product.sold && !isFeatureItem;

  return (
    <div className="col mb-5">
      <div className="card h-100">
        {/* Badges */}
        {product.sold && (
          <div className="badge bg-danger text-white position-absolute" style={{ top: '0.5rem', right: '0.5rem' }}>
            SOLD
          </div>
        )}
        {product.salePrice && !product.sold && (
          <div className="badge bg-dark text-white position-absolute" style={{ top: '0.5rem', right: '0.5rem' }}>
            Sale
          </div>
        )}

        {/* Image */}
        <img className="card-img-top" src={product.image} alt={product.name} />

        {/* Body */}
        <div className="card-body p-4">
          <div className="text-center">
            <h5 className="fw-bolder">{product.name}</h5>
            <p className="text-muted">Size: {product.size || 'N/A'}</p>
            <p className="text-muted">ID: {product.id}</p>

            {/* Price */}
            {product.salePrice ? (
              <>
                <span className="text-muted text-decoration-line-through">
                  ${product.originalPrice ? product.originalPrice.toFixed(2) : 'N/A'}
                </span>{' '}
                <span className="text-danger">
                  ${Number(product.salePrice).toFixed(2)}
                </span>
              </>
            ) : (
              <span>${product.price ? Number(product.price).toFixed(2) : 'N/A'}</span>
            )}
          </div>
        </div>

        {/* Footer actions */}
        <div className="card-footer p-4 pt-0 border-top-0 bg-transparent">
          <div className={`d-grid gap-2 ${isHome ? '' : 'd-md-flex justify-content-center'}`}>
            <button
              className="btn btn-outline-dark mt-auto"
              onClick={() => onViewDetails(product)}
              disabled={product.sold}
              aria-label={`View details for ${product.name}`}
            >
              {product.sold ? 'Sold Out' : 'View Details'}
            </button>

            {/* Show Add to Cart on all pages EXCEPT home */}
            {!isHome && (
              <button
                className="btn btn-dark mt-auto"
                onClick={() => addToCart(product)}
                disabled={!canAdd}
                aria-label={`Add ${product.name} to cart`}
              >
                Add to Cart
              </button>
            )}
          </div>

          {/* Optional helper text for Feature items */}
          {!isHome && isFeatureItem && !product.sold && (
            <small className="d-block mt-2 text-muted text-center">
              Featured item — cannot be added to cart
            </small>
          )}
        </div>
      </div>
    </div>
  );
});

export default ProductCard;
